<div [@casePracticeTeamAuthAnimation] id="wrap" *ngIf="questions" (click)="screenClick()">

  <div id="numberWrap" class="numberWrap{{mode}}">
    <div class="circle active fontSize16">
      1
    </div>

    <div class="line"></div>

    <div class="circle active fontSize16">
      2
    </div>

    <div class="line" *ngIf="mode==1"></div>

    <div class="circle active fontSize16" *ngIf="mode==1">
      3
    </div>
  </div>

  <div id="btnwrap">
  	<div id="reviewBtn" class="fontSize16 imgAble" (click)="reviewConversation($event)">场景回顾</div>
  	<div id="reviewBtn2" class="fontSize16 imgAble" (click)="reviewConversation($event)">场景回顾</div>
  	<div id="taskBtn" class="fontSize16 imgAble" *ngIf="mode==1" (click)="taskBookOut($event)">任务书</div>
  </div>
  <div id="taskBookBox" [innerHtml]="taskBook" class="fontSize16 lineHeight24">
  </div>

  <div id="reviewBox">
    <!--<div id="reviewBoxTitle" class="fontSize18 lineHeight24" >-->
      <!--场景回顾-->
    <!--</div>-->
    <p class="excellentDemonstrationTitle flowerBorderBottom">场景回顾</p>

    <div id="discussionBackground" *ngIf="mode==2" (click)="discussionBgClick($event)">
        <div id="discussionBackgroundHead" class="fontSize14">
            讨论背景
          <i class="fa fa-caret-up fa-lg discussionBgIcon" *ngIf="discussionBgMainMode==1"></i>
          <i class="fa fa-caret-down fa-lg discussionBgIcon" *ngIf="discussionBgMainMode==0"></i>
        </div>
      <div id="discussionBackgroundMain" class="fontSize14 discussionBgMain_{{discussionBgMainMode}}">
        一个月过去了，你也从项目初期的激动中渐渐感受到不一样的滋味。<br/><br/>
        部门与部门之间的协作似乎并没有你想象的那样顺利。往往是战略部召开的定期会议结束以后，下一次问题回顾依然没有丝毫进展。<br/><br/>
        你作为营销部门的负责人，准备采取行动，希望通过建立良好的伙伴关系，将方案的推进变得更加顺利起来。<br/><br/>
        你决定先从研发部门的方科科开始。
      </div>
    </div>

      <div class="reviewItem" *ngFor="let item of conversationHistory;let i=index">
        <div class="reviewRole fontSize14 lineHeight24" *ngIf="item.role=='高朗'||item.role=='方科科'||item.role=='我'" [ngClass]="{'reviewRole1':item.role=='高朗'||item.role=='方科科','reviewRole2':item.role=='我','reviewRole3':item.role=='导师点评'}">
          {{item.role}}
        </div>
        <div class="reviewComment fontSize14 lineHeight21" *ngIf="item.role!='导师点评'">
          {{item.comment}}
        </div>
        <div class="bg-lightBlue" *ngIf="item.role=='导师点评'">
        <div class="fontSize14 lineHeight24 excellentDemonstrationTitle">
          {{item.role}}
        </div>
          <div class="reviewComment2 fontSize14 lineHeight21" >
            {{item.comment}}
          </div>
        </div>
      </div>
  </div>

<div id="taskBookBox" [innerHtml]="taskBook" class="fontSize16 lineHeight24">
</div>

  <div id="shade"></div>
  <div id="closeBtn" (click)="closeTip($event)"></div>

  <!--<img src="{{assetsRoute}}/picture/casepracticeauthorization/gl1.png" alt="" id="gl">-->
  <img src="{{assetsRoute}}/picture/casepracticeauthorization/happy.png" alt="" id="happy">
  <img src="{{assetsRoute}}/picture/casepracticeauthorization/worry.png" alt="" id="worry">
  <img src="{{assetsRoute}}/picture/casepracticeauthorization/doubt.png" alt="" id="doubt">
  <img src="{{assetsRoute}}/picture/casepracticeauthorization/narration.png" alt="" id="narration">

  <img src="{{assetsRoute}}/picture/casepracticecooperation/common_new.png" alt="" id="common">
  <img src="{{assetsRoute}}/picture/casepracticecooperation/frown_new.png" alt="" id="frown">
  <img src="{{assetsRoute}}/picture/casepracticecooperation/proud_new.png" alt="" id="proud">
  <img src="{{assetsRoute}}/picture/casepracticecooperation/eyebrow_new.png" alt="" id="eyebrow">
  <img src="{{assetsRoute}}/picture/casepracticecooperation/sweat_new.png" alt="" id="sweat">
  <img src="{{assetsRoute}}/picture/casepracticecooperation/angry_new.png" alt="" id="angry">

  <img src="{{assetsRoute}}/picture/casepracticeteam/notice.png" alt="" [@noticeAnimation]="noticeShow ? 'showNotice' : 'hideNotice'" id="notice">

  <div id="talkBox1">
      <div id="talkBoxContent1" class="fontSize16">
         <!-- {{currentWord}} -->
      </div>
      <div class="talkBoxContentFake fontSize16" [innerHtml]="currentFakeWord">
      </div>
      <div id="talkBoxName1" class="fontSize16">
         我
      </div>
  </div>

  <div id="talkBox2" class="talkBox2_{{mode}}">
    <div id="talkBoxContent2" class="fontSize16">
         <!-- {{currentWord}} -->
    </div>
    <div class="talkBoxContentFake fontSize16" [innerHtml]="currentFakeWord">
    </div>
    <div id="talkBoxName2" class="fontSize16 talkBoxName2_{{mode}}">
      <span *ngIf="mode==1">高朗</span>
      <span *ngIf="mode==2">方科科</span>
    </div>
  </div>

  <div id="tutorHints" class="fontSize14">
    <div id="tutorHintsContent">
    </div>
    <div id="tutorHintsFake" [innerHtml]="currentFakeWord">
    </div>
  </div>

  <div id="talkBack" class="fontSize16">
    <h2 class="fontSize24">讨论背景</h2>
    一个月过去了，你也从项目初期的激动中渐渐感受到不一样的滋味。<br/><br/>
    部门与部门之间的协作似乎并没有你想象的那样顺利。往往是战略部召开的定期会议结束以后，下一次问题回顾依然没有丝毫进展。<br/><br/>
    你作为营销部门的负责人，准备采取行动，希望通过建立良好的伙伴关系，将方案的推进变得更加顺利起来。<br/><br/>
    你决定先从研发部门的方科科开始。
  </div>

  <div id="introductionBox">
    <div id="nameBox" class="fontSize18 lineHeight32 nameBox3">
      <span>方科科</span>
    </div>
    <div id="introduction" class="fontSize16 lineHeight24">
        熟悉业务，有抱负，有想法<br/>
        为人谨慎，对变化持保守态度<br/>
        喜欢用数据说话，不爱主观臆想<br/>
        智商高情商低，直球型沟通方式
    </div>
  </div>


  <div [@optionWrapAnimation]="optionWrapShow ? 'showOptionWrap': 'hideOptionWrap'" id="optionsWrap">
    <div class="optionTips">长按按钮进行选择</div>

   <div *ngIf="!type">
     <div class="optionItem fontSize14" id="option_{{i}}" *ngFor="let option of currentOptions;let i=index"  (touchstart)="onOptionMouseDown(i, $event)"  (touchend)="onOptionMouseUp($event)">
       {{option.description}}
       <div class="loading"><div class='dotting' id='dotting1'></div><div class='dotting' id='dotting2'></div><div class='dotting' id='dotting3'></div></div>
       <div class="pressing"><div class="pressingOption">{{option.description}}</div></div>
     </div>
   </div>

    <div *ngIf="type">
      <div class="optionItem fontSize14" id="option_{{i}}" *ngFor="let option of currentOptions;let i=index"  (mousedown)="onOptionMouseDown(i, $event)" (mouseup)="onOptionMouseUp($event)" >
        {{option.description}}
        <div class="loading"><div class='dotting' id='dotting1'></div><div class='dotting' id='dotting2'></div><div class='dotting' id='dotting3'></div></div>
        <div class="pressing"><div class="pressingOption">{{option.description}}</div></div>
      </div>
    </div>



  </div>

  <div id="generateReportBtn" class="fontSize18" (click)="linkToReport()">
      生成并查看报告
  </div>

</div>



// WEBPACK FOOTER //
// ./src/app/case-practice-authorization-main/case-practice-authorization-main.component.html